import React, { useCallback } from "react";
import {useDispatch} from "react-redux";
import {Translation as T} from "@awe-web/shared/lib";

import { useInitialize } from "../../../util/react.js";
import {ScreenSection, ScreenHeading, ScreenLoading,} from "../../../components/screen.js";
import {TypeArea} from "../../../components/layout.js";
import {Row, Col} from "../../../components/grid.js";
import SignUpConfirmedForm from "./sign_up_confirmed_form";
import {initialize} from "./actions.js";

import "./sign_up_confirmed.scss";

const REGISTRATION_SUCCESSFUL = "FSD0000210";

export default function B2C_SignUpConfirmed() {
  const dispatch = useDispatch();

  const init = useCallback(async () => await dispatch(initialize()), [dispatch]);
  const isReady = useInitialize(init);
  
  if (!isReady) {
    return <ScreenLoading />;
  }

  return (
    <div className="sign-up-confirmed">
      <ScreenSection dark>
        <TypeArea>
          <Row>
            <Col desktop={{cols: 8, offset: 2}}>
              <ScreenHeading>
                <T code={REGISTRATION_SUCCESSFUL} />
              </ScreenHeading>
            </Col>
          </Row>          
        </TypeArea>
      </ScreenSection>      
      <ScreenSection main dark>
        <TypeArea>
          <SignUpConfirmedForm />
        </TypeArea>
      </ScreenSection>
    </div>
  );
}
